import { useTranslation } from 'react-i18next';
import Box from '../../components/fela/Box';
import PhotoPreview from '../../components/file-uploader/photo-preview';
import { CustomFileError, DroppedFile } from '../../components/file-uploader/types';
import UploadingError from '../../components/file-uploader/uploading-error';
import UploadingProgress from '../../components/file-uploader/uploading-progress';
import { styles } from './uploading-file-style';

type Props = {
  droppedFiles: Array<DroppedFile>;
  errors: Array<CustomFileError>;
  uploadType?: 'photo' | 'file' | '*';
  multiple?: boolean;
  disablePreview?: boolean;
};

const UploadingFile = ({ droppedFiles, errors, uploadType, disablePreview }: Props) => {
  const { t } = useTranslation('ui');
  const files = droppedFiles.map((file) => {
    const hasError = errors.filter((error) => error.file === file.file);
    if (hasError.length > 0) file.msg = hasError[0].msg;
    return file;
  });

  return (
    <Box style={styles.uploading}>
      {files.length > 0 && (
        <Box style={styles.fileUploadingWrap}>
          {files.map((dropped, index) => (
            <Box style={styles.fileUploadingCol} key={`file-uploading-${index}`}>
              {!dropped.msg ? (
                <div>
                  {disablePreview ? (
                    t('uploading') + ' ' + dropped.file.name
                  ) : (
                    <PhotoPreview {...{ dropped, style: styles, uploadType }} />
                  )}
                  <UploadingProgress {...{ dropped, style: styles }} />
                </div>
              ) : (
                <UploadingError {...{ dropped, style: styles }} />
              )}
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default UploadingFile;
